import { createFileRoute } from '@tanstack/react-router'
import MetaDataType from 'Metadata/components/MetaDataType'

export const Route = createFileRoute('/metadata/$metaDataTypeId')({
    component: MetaDataType,
})
